/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

const CloseShiftStatus = {
  edit: {
    name: 'สแกน',
    color: 'warning',
    icon: 'qr_code_scanner',
  },
  counting: {
    name: 'นับเงิน',
    color: 'warning',
    icon: 'hourglass_top',
  },
  photo: {
    name: 'ถ่ายภาพ',
    color: 'warning',
    icon: 'camera_alt',
  },
  summary: {
    name: 'ยอดนำส่ง',
    color: 'warning',
    icon: 'price_change',
  },
  success: {
    name: 'ปิดรอบ',
    color: 'info',
    icon: 'task_alt',
  },
  approve: {
    name: 'อนุมัติ',
    color: 'success',
    icon: 'task_alt',
  },
  reject: {
    name: 'ไม่อนุมัติ',
    color: 'error',
    icon: 'highlight_off_outlined',
  },
  cancel: {
    name: 'ยกเลิก',
    color: 'error',
    icon: 'cancel',
  },
};

export default CloseShiftStatus;
